import React, { useState } from 'react';
import { Header } from '../Shared/Header';
import { Sidebar } from '../Shared/Sidebar';
import { CapitalMarketsDashboard } from './CapitalMarketsDashboard';
import { PoolBuilder } from './PoolBuilder';
import { Surveillance } from './Surveillance';
import { CounterpartyProfiles } from './CounterpartyProfiles';
import { LineageView } from './LineageView';
import { ExportBuilder } from './ExportBuilder';
import { DBRSReporting } from './DBRSReporting';
import { Exceptions } from './Exceptions';
import { ComplianceTracker } from './ComplianceTracker';
export function CapitalMarketsPage() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const navigationItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'LayoutDashboard'
  }, {
    id: 'poolBuilder',
    label: 'Pool Builder',
    icon: 'FolderPlus'
  }, {
    id: 'surveillance',
    label: 'Surveillance',
    icon: 'Calendar'
  }, {
    id: 'counterparties',
    label: 'Counterparties',
    icon: 'Users'
  }, {
    id: 'lineage',
    label: 'Data Lineage',
    icon: 'GitBranch'
  }, {
    id: 'exportBuilder',
    label: 'Export Builder',
    icon: 'FileOutput'
  }, {
    id: 'dbrsReporting',
    label: 'DBRS Reporting',
    icon: 'FileCheck'
  }, {
    id: 'exceptions',
    label: 'Exceptions',
    icon: 'AlertTriangle'
  }, {
    id: 'compliance',
    label: 'Compliance',
    icon: 'History'
  }];
  const renderActiveTab = () => {
    switch (activeTab) {
      case 'dashboard':
        return <CapitalMarketsDashboard data-id="element-86" />;
      case 'poolBuilder':
        return <PoolBuilder data-id="element-87" />;
      case 'surveillance':
        return <Surveillance data-id="element-88" />;
      case 'counterparties':
        return <CounterpartyProfiles data-id="element-89" />;
      case 'lineage':
        return <LineageView data-id="element-90" />;
      case 'exportBuilder':
        return <ExportBuilder data-id="element-91" />;
      case 'dbrsReporting':
        return <DBRSReporting setActiveTab={setActiveTab} data-id="element-92" />;
      case 'exceptions':
        return <Exceptions data-id="element-93" />;
      case 'compliance':
        return <ComplianceTracker data-id="element-94" />;
      default:
        return <CapitalMarketsDashboard data-id="element-95" />;
    }
  };
  return <div className="grid h-screen grid-rows-[auto,1fr] bg-background" data-id="element-96">
      <Header title="Capital Markets" data-id="element-97" />
      <div className="overflow-auto" data-id="element-98">
        <div className="grid h-full grid-cols-1 grid-rows-[auto,1fr] sm:grid-cols-[14rem,1fr] sm:grid-rows-1" data-id="element-99">
          <Sidebar navigationItems={navigationItems} activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-100" />
          <main className="h-full overflow-auto p-6 bg-background" data-id="element-101">
            {renderActiveTab()}
          </main>
        </div>
      </div>
    </div>;
}